import { Component, Input, OnInit } from '@angular/core';
import { SalesManagementCounts } from 'src/app/core/interfaces/status-counts/sales-management-counts';

@Component({
  selector: 'app-sales-management-counts',
  templateUrl: './sales-management-counts.component.html',
  styleUrls: ['./sales-management-counts.component.scss'],
})
export class SalesManagementCountsComponent implements OnInit {
  @Input() salesManagementCounts: SalesManagementCounts;

  constructor() {}

  ngOnInit(): void {}
}
